const firebaseConfig = {
    apiKey: "AIzaSyDIslC-9nAQhjCZ6e9QILOU5qAVUNScaIM",
    authDomain: "assignment-10-a8eff.firebaseapp.com",
    projectId: "assignment-10-a8eff",
    storageBucket: "assignment-10-a8eff.appspot.com",
    messagingSenderId: "383844200877",
    appId: "1:383844200877:web:757df9a4cd277a1170f124"
  };

  export default firebaseConfig;